export default "/images/9a70261ea57d10735e91672a16de40fa.avif";